import create from 'zustand'
import { persist } from 'zustand/middleware'

const useRaffleState = create(persist(
  (set) => ({
    // The user's address and balance
    selectedAddress: undefined,
    // The ID about transactions being sent, and any possible error with them
    txBeingSent: undefined,
    transactionError: undefined,
    networkError: undefined,
    raffle: undefined,
    provider: undefined,
    registered: undefined,
  }),
  {
    name: 'raffle-storage',
    getStorage: () => sessionStorage
  }
));

export default useRaffleState;
